import { CSSProperties } from 'react';

type LoaderProps = {
    width?: number | string;
    height?: number | string;
    fill?: CSSProperties['fill'];
};

export const Loader = ({ width = 24, height = 24, fill = 'var(--color-black)' }: LoaderProps) => {
    return (
        <svg
            className="loader"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
            width={width}
            height={height}
            style={{ shapeRendering: 'auto', display: 'block', background: 'transparent' }}
        >
            <g>
                <g transform="rotate(0 50 50)">
                    <rect fill={fill} height="12" width="6" ry="5.64" rx="3" y="20" x="47">
                        <animate
                            repeatCount="indefinite"
                            begin="-4.365079365079365s"
                            dur="4.761904761904762s"
                            keyTimes="0;1"
                            values="1;0"
                            attributeName="opacity"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(30 50 50)">
                    <rect fill={fill} height="12" width="6" ry="5.64" rx="3" y="20" x="47">
                        <animate
                            repeatCount="indefinite"
                            begin="-3.9682539682539675s"
                            dur="4.761904761904762s"
                            keyTimes="0;1"
                            values="1;0"
                            attributeName="opacity"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(60 50 50)">
                    <rect fill={fill} height="12" width="6" ry="5.64" rx="3" y="20" x="47">
                        <animate
                            repeatCount="indefinite"
                            begin="-3.5714285714285707s"
                            dur="4.761904761904762s"
                            keyTimes="0;1"
                            values="1;0"
                            attributeName="opacity"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(90 50 50)">
                    <rect fill={fill} height="12" width="6" ry="5.64" rx="3" y="20" x="47">
                        <animate
                            repeatCount="indefinite"
                            begin="-3.174603174603174s"
                            dur="4.761904761904762s"
                            keyTimes="0;1"
                            values="1;0"
                            attributeName="opacity"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(120 50 50)">
                    <rect fill={fill} height="12" width="6" ry="5.64" rx="3" y="20" x="47">
                        <animate
                            repeatCount="indefinite"
                            begin="-2.7777777777777772s"
                            dur="4.761904761904762s"
                            keyTimes="0;1"
                            values="1;0"
                            attributeName="opacity"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(150 50 50)">
                    <rect fill={fill} height="12" width="6" ry="5.64" rx="3" y="20" x="47">
                        <animate
                            repeatCount="indefinite"
                            begin="-2.3809523809523805s"
                            dur="4.761904761904762s"
                            keyTimes="0;1"
                            values="1;0"
                            attributeName="opacity"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(180 50 50)">
                    <rect fill={fill} height="12" width="6" ry="5.64" rx="3" y="20" x="47">
                        <animate
                            repeatCount="indefinite"
                            begin="-1.9841269841269837s"
                            dur="4.761904761904762s"
                            keyTimes="0;1"
                            values="1;0"
                            attributeName="opacity"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(210 50 50)">
                    <rect fill={fill} height="12" width="6" ry="5.64" rx="3" y="20" x="47">
                        <animate
                            repeatCount="indefinite"
                            begin="-1.587301587301587s"
                            dur="4.761904761904762s"
                            keyTimes="0;1"
                            values="1;0"
                            attributeName="opacity"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(240 50 50)">
                    <rect fill={fill} height="12" width="6" ry="5.64" rx="3" y="20" x="47">
                        <animate
                            repeatCount="indefinite"
                            begin="-1.1904761904761902s"
                            dur="4.761904761904762s"
                            keyTimes="0;1"
                            values="1;0"
                            attributeName="opacity"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(270 50 50)">
                    <rect fill={fill} height="12" width="6" ry="5.64" rx="3" y="20" x="47">
                        <animate
                            repeatCount="indefinite"
                            begin="-0.7936507936507935s"
                            dur="4.761904761904762s"
                            keyTimes="0;1"
                            values="1;0"
                            attributeName="opacity"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(300 50 50)">
                    <rect fill={fill} height="12" width="6" ry="5.64" rx="3" y="20" x="47">
                        <animate
                            repeatCount="indefinite"
                            begin="-0.39682539682539675s"
                            dur="4.761904761904762s"
                            keyTimes="0;1"
                            values="1;0"
                            attributeName="opacity"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(330 50 50)">
                    <rect fill={fill} height="12" width="6" ry="5.64" rx="3" y="20" x="47">
                        <animate repeatCount="indefinite" begin="0s" dur="4.761904761904762s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
                    </rect>
                </g>
            </g>
        </svg>
    );
};
